// https://github.com/moment/moment/issues/2979
import moment from 'moment';
import 'moment-timezone';
import * as locales from 'date-fns/locale';
import { sortArray } from './index';
export var DATE_FORMAT = 'L LT';
export var getTimeZones = function () {
    var _a;
    var timeZones = (_a = moment.tz) === null || _a === void 0 ? void 0 : _a.names();
    return timeZones
        .map(function (timeZone) {
        var time = "(GMT".concat(moment
            .tz(timeZone)
            .format('Z')
            .replace(/\w+,/g, '')
            .replace(/\s+/g, '')
            .replace(/\+{2}/g, '+'), ")");
        var offset = moment.tz(timeZone).format('Z').replace(/\w+,/i, '');
        var arr = offset.match(/(\+|-)(\d+)(:)(\d+)/i);
        var parsed = parseInt("".concat(arr[1]).concat(arr[2]), 10);
        return {
            label: "".concat(time, " ").concat(timeZone.replace(/_/g, ' ')),
            offset: parsed,
            value: timeZone,
        };
    })
        .filter(function (timeZone) { return timeZone.label.indexOf('/') >= 0; })
        .filter(function (timeZone) { return timeZone.label.indexOf('Etc/') === -1; })
        .sort(sortArray('offset'))
        .map(function (timeZone) { return ({
        label: timeZone.label,
        value: timeZone.value,
    }); });
};
/** Zenoo's answer on https://stackoverflow.com/questions/673905/best-way-to-determine-users-locale-within-browser */
var getNavigatorLanguage = function () {
    return navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.userLanguage ||
            navigator.language ||
            navigator.browserLanguage ||
            'en';
};
export var getLocale = function () {
    var locale = getNavigatorLanguage();
    var dateFnsLocal = locales[locale.replace('-', '').replace('_', '')];
    if (dateFnsLocal) {
        return { locale: locale, dateFnsLocale: dateFnsLocal };
    }
    return { locale: 'en', dateFnsLocale: locales.enUS };
};
/** sets moment locale and returns a moment instance
 * if passed a registerLocale function as an argument, runs it with ex: `('en-US', enUS) => ...`
 *
 * registerLocale >> `import { registerLocale } from 'react-datepicker'`
 *
 * enUS >> `import enUS from 'date-fns/locale/enUS'` */
export var setLocale = function (registerLocale) {
    var _a = getLocale(), locale = _a.locale, dateFnsLocale = _a.dateFnsLocale;
    if (registerLocale) {
        // for react-datepicker locale registration
        registerLocale(locale, dateFnsLocale);
    }
};
export var formatDate = function (date) {
    return moment(date).locale(getLocale().locale).format(DATE_FORMAT);
};
export var toDate = function (date) {
    return (date && moment(date).toDate()) || moment().toDate();
};
export var getDifferenceBetweenTwoDatesString = function (startSentenceWith, since, endSentenceWith) {
    var sinceWhen = moment(since);
    var sinceNow = moment();
    if (sinceNow.diff(sinceWhen, 'years') === 0) {
        if (sinceNow.diff(sinceWhen, 'months') === 0) {
            if (sinceNow.diff(sinceWhen, 'days') === 0) {
                if (sinceNow.diff(sinceWhen, 'hours') === 0) {
                    if (sinceNow.diff(sinceWhen, 'minutes') === 0) {
                        return "".concat(startSentenceWith, " ").concat(sinceNow.diff(sinceWhen, 'seconds'), " ").concat(sinceNow.diff(sinceWhen, 'seconds') >= 2 ? 'seconds' : 'second', " ").concat(endSentenceWith);
                    }
                    else {
                        return "".concat(startSentenceWith, " ").concat(sinceNow.diff(sinceWhen, 'minutes'), " ").concat(sinceNow.diff(sinceWhen, 'minutes') >= 2 ? 'minutes' : 'minute', " ").concat(endSentenceWith);
                    }
                }
                else {
                    return "".concat(startSentenceWith, " ").concat(sinceNow.diff(sinceWhen, 'hours'), " ").concat(sinceNow.diff(sinceWhen, 'hours') >= 2 ? 'hours' : 'hour', " ").concat(endSentenceWith);
                }
            }
            else {
                return "".concat(startSentenceWith, " ").concat(sinceNow.diff(sinceWhen, 'days'), " ").concat(sinceNow.diff(sinceWhen, 'days') >= 2 ? 'days' : 'day', " ").concat(endSentenceWith);
            }
        }
        else {
            return "".concat(startSentenceWith, " ").concat(sinceNow.diff(sinceWhen, 'months'), " ").concat(sinceNow.diff(sinceWhen, 'months') >= 2 ? 'months' : 'month', " ").concat(endSentenceWith);
        }
    }
    else {
        return "".concat(startSentenceWith, " ").concat(sinceNow.diff(sinceWhen, 'years'), " ").concat(sinceNow.diff(sinceWhen, 'years') >= 2 ? 'years' : 'year', " ").concat(endSentenceWith);
    }
};
